import { render, staticRenderFns } from "./elvas-button.vue?vue&type=template&id=0c576698&scoped=true&"
import script from "./elvas-button.vue?vue&type=script&lang=js&"
export * from "./elvas-button.vue?vue&type=script&lang=js&"
import style0 from "./elvas-button.vue?vue&type=style&index=0&id=0c576698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c576698",
  null
  
)

export default component.exports